<template>
    <div class="help-center-faq">
        <h6 class="faq-question">{{ faq.q }}</h6>
        <div class="faq-answer" v-html="faq.a"></div>
    </div>
</template>

<script>
export default {
    name: 'HelpCenterFaq',
    props: {
        faq: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.help-center-faq {
    .faq-question {
        color: #fff;
    }

    .faq-answer {
        color: $light;
    }

    @media screen and #{$new-break1} {
        background: $dark-3;
        margin-bottom: 1rem;
        padding: 1rem;

        .faq-question {
            font-size: 1rem;
            margin-bottom: 1rem;
        }

        .faq-answer {
            font-size: 0.85rem;
        }
    }
    @media screen and #{$new-break2open} {
        margin-bottom: 3rem;

        .faq-question {
            font-size: 1.25rem;
            margin-bottom: 1rem;
        }

        .faq-answer {
            font-size: 1rem;
        }
    }
    @media screen and #{$new-break3open} {
        margin-bottom: 5rem;
    }
}
</style>
